





























































import { Scrollbar } from '@/app/components';
import { RefreshIcon } from '@vue-hero-icons/solid';
import { computed, defineComponent } from '@vue/composition-api';
import { OrbitSpinner } from 'epic-spinners';
import DataIngestionExecutions from '../components/dashboard/DataIngestionExecutions.vue';
import MetricCard from '../components/dashboard/MetricCard.vue';
import { useDashboard } from '../composable';
import { DashboardStatistic } from '../interfaces';
import store from '../store';

export default defineComponent({
    name: 'Dashboard',
    metaInfo: { title: 'Dashboard' },
    components: {
        OrbitSpinner,
        RefreshIcon,
        DataIngestionExecutions,
        MetricCard,
        Scrollbar,
    },
    setup() {
        const user = computed(() => store.state.auth.user);
        const {
            asset,
            pipelineAndRetrieval,
            loading,
            lastUpdatedOn: statisticsLastUpdatedOn,
            lastUpdatedSince: statisticsLastUpdatedSince,
            refetch,
        } = useDashboard();

        /**
         * Asset and pipeline/retrieval statistics are shown as two separate rows, unless disabled
         * features have left few enough of them to fit in a single row - in which case they are
         * merged, so that no gap is left behind by a hidden metric.
         */
        const statisticRows = computed(() => {
            const rows = [asset.value, pipelineAndRetrieval.value].filter(
                (statistics: DashboardStatistic[]) => statistics.length > 0,
            );
            const total = rows.reduce(
                (count: number, statistics: DashboardStatistic[]) => count + statistics.length,
                0,
            );
            return total <= 3 ? [rows.flat()] : rows;
        });

        return {
            loading,
            statisticRows,
            statisticsLastUpdatedOn,
            statisticsLastUpdatedSince,
            refetch,
            user,
        };
    },
});
